"use client"

import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils"
import { EMS_TAB_BAR, EMS_RADIX_TRIGGER } from "./ems-tabs"

function Tabs({
    className,
    orientation = "horizontal",
    ...props
}: React.ComponentProps<typeof TabsPrimitive.Root>) {
    return (
        <TabsPrimitive.Root
            data-slot="tabs"
            data-orientation={orientation}
            orientation={orientation}
            className={cn("group/tabs flex gap-2 data-[orientation=horizontal]:flex-col", className)}
            {...props} />
    );
}

// Chuẩn tab EMS (components/ui/ems-tabs): thẻ trên đường kẻ đáy, tab đang chọn chữ đậm + gạch chân đậm.
// Giữ prop `variant` để không vỡ chỗ đang truyền; mọi biến thể dùng chung một kiểu.
const tabsListVariants = cva(
    `${EMS_TAB_BAR} h-auto w-full justify-start rounded-none bg-transparent p-0 overflow-x-auto no-scrollbar text-muted-foreground group/tabs-list`,
    {
        variants: {
            variant: {
                default: "",
                line: "",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
)

function TabsList({
    className,
    variant = "default",
    ...props
}: React.ComponentProps<typeof TabsPrimitive.List> & VariantProps<typeof tabsListVariants>) {
    return (
        <TabsPrimitive.List
            data-slot="tabs-list"
            data-variant={variant}
            className={cn(tabsListVariants({ variant }), className)}
            {...props} />
    );
}

function TabsTrigger({
    className,
    ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
    return (
        <TabsPrimitive.Trigger
            data-slot="tabs-trigger"
            className={cn(EMS_RADIX_TRIGGER, className)}
            {...props} />
    );
}

function TabsContent({
    className,
    ...props
}: React.ComponentProps<typeof TabsPrimitive.Content>) {
    return (
        <TabsPrimitive.Content
            data-slot="tabs-content"
            className={cn("flex-1 outline-none", className)}
            {...props} />
    );
}

export { Tabs, TabsList, TabsTrigger, TabsContent, tabsListVariants }
